import commnetsPropertiesProvider from './commnetsPropertiesProvider';

export default {
  __init__: [ 'commnetsPropertiesProvider' ],
  commnetsPropertiesProvider: [ 'type', commnetsPropertiesProvider ]
};